'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.service('session', function ($rootScope, $ionicLoading, $http, $ionicHistory, $state, localStorage, USER_ROLES, EVENTS, jAlert) {

    var self = this;

    /**
     * accessToken 有效时间 天数 转换为毫秒数
     */
    var tokenEffectiveTime = 6 * 24 * 60 * 60 * 1000;

    self.userInfo = {};

    /**
     * 保存到localStorage
     */
    self.save = function () {
      localStorage.set('userInfo', this.userInfo);
    };

    /**
     * 重置用户信息 用于注销
     */
    self.reset = function () {
      this.updateOptions({
        username: '',
        password: '',
        // 用户拥有的角色 可以有多个
        roles: [],
        avatar: '',
        realName: '',
        apiVersion: '',
        tokenType: '',
        accessToken: '',
        accessTokenFull: '',
        refreshToken: '',
        tokenExpirationTime: 0,
        depId: '',
        driverId: '',
        SIMID: ''
      });
    };

    /**
     * 更新用户信息
     * @param {Object} options
     */
    self.updateOptions = function (options) {
      if (options) {
        for (var key in options) {
          if (options.hasOwnProperty(key)) {
            this.userInfo[key] = options[key];
          }
        }
      }
    };

    /**
     * 保存登录信息
     * @param {Object} options
     */
    self.login = function (options) {
      if (options) {
        this.updateOptions({
          roles: options.roles || [],
          depId: options.depId || '',
          driverId: options.driverId || '',
          SIMID: options.SIMID || '',
          username: options.username || '',
          password: options.password || '',
          realName: options.realName || '',
          tokenType: options.tokenType || '',
          accessToken: options.accessToken || '',
          accessTokenFull: (options.tokenType || '') + ' ' + (options.accessToken || ''),
          refreshToken: options.refreshToken,
          tokenExpirationTime: new Date().getTime() + tokenEffectiveTime
        });
        this.save();
      }
    };

    /**
     * 注销当前用户
     */
    self.logout = function () {
      var username = this.userInfo.username;
      this.reset();
      this.updateOptions({
        username: username
      });
      this.save();
      $rootScope.$emit(EVENTS.logoutSuccess);
    };

    /**
     * 判断用户是否登录
     */
    self.isAuthenticated = function () {
      return !!(this.userInfo && this.userInfo.username && this.userInfo.accessToken && this.userInfo.roles.indexOf(USER_ROLES.common) >= 0);
    };

    /**
     * 对于指定的角色组 判断当前用户是否已授权
     * @param {Array} authorizedRoles
     * 没有指定角色组 视为已授权
     * @return {Object}
     * permissible：是否有权限访问
     * unauthorizedRoles：未符合的角色组 若数量和小于指定的角色组 视为 已授权 否则为 未授权
     */
    self.isAuthorized = function (authorizedRoles) {
      if (!(0, _objectType.isArray)(authorizedRoles)) {
        authorizedRoles = [];
      }
      var length = authorizedRoles.length,
          authorizedRolesNew = [];
      if (length) {
        // 先判断用户登录是否过期
        if (this.isExpires()) {
          return {
            permissible: false,
            unauthorizedRoles: authorizedRoles
          };
        }
        var temp = void 0,
            temp2 = false;
        for (var i = 0; i < length; i++) {
          temp = authorizedRoles[i];
          for (var j = 0; j < this.userInfo.roles.length; j++) {
            if (temp === this.userInfo.roles[j]) {
              temp2 = true;
              break;
            }
          }
          if (!temp2) {
            authorizedRolesNew.push(temp);
            temp2 = false;
          }
        }
      }
      return {
        permissible: !length || authorizedRolesNew.length < length,
        unauthorizedRoles: authorizedRolesNew
      };
    };

    /**
     * 判断用户登录信息是否过期
     */
    self.isExpires = function () {
      if (self.userInfo && self.userInfo.accessToken) {
        // 和当前时间戳比较
        if (self.userInfo.tokenExpirationTime <= new Date().getTime() || !self.userInfo.accessToken) {
          return true;
        }
      }
      return false;
    };

    /**
     * 根据refreshToken 刷新 accessToken
     */
    self.refreshToken = function () {
      // 目前 只做注销帐号操作
      self.logout();
      jAlert.showOnce({
        message: '登录时效已过期，请重新登录'
      });
    };

    // 获取已保存的数据
    var fs = localStorage.get('userInfo');

    self.reset();

    self.updateOptions(fs);

    // 若token过期 则注销当前用户
    if (self.isExpires()) {
      self.logout();
    }

    // 刷新access_token
    $rootScope.$on(EVENTS.refreshToken, function () {});

    return self;
  });
  return app;
};

var _objectType = require('../lib/utils/objectType');

/**
 * Session
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/app/session.js
// module id = 38
// module chunks = 0